import { FC, useState } from 'react'
import { TextFieldProps } from '@mui/material/TextField'
import * as Styles from './styles'
import { matchIsValidTel } from 'mui-tel-input'

export type TPhoneFieldProps = TextFieldProps & {
  id: string,
  setIsInvalidForm?: (value: boolean) => void
}

const PhoneField: FC<TPhoneFieldProps> = (props) => {
  const propsWithoutCustom = { ...props }
  delete propsWithoutCustom.setIsInvalidForm
  const [phone, setPhone] = useState<string>('')

  const handleChange = (newPhone: string) => {
    setPhone(newPhone)
    props.setIsInvalidForm?.(!matchIsValidTel(newPhone))
  }

  return (
    <Styles.PhoneField
      name={props.id}
      size="small"
      variant="outlined"
      data-testid="ContainerPhoneField"
      inputProps={{ 'data-testid': `PhoneField-${props.id}` }}
      defaultCountry="US"
      value={phone}
      onChange={handleChange}
      placeholder="+1 (555) 000-0000"
      {...propsWithoutCustom}
    />
  )
}

export default PhoneField
